import { AREAS } from './areas';

// Prompt for the REVIEWING phase ("Understanding Review"). Compass reads the
// conversation so far and returns ONLY JSON describing its current understanding
// of each of the six areas. The transcript is embedded here (the builder "reads
// the conversation"); the component sends a short trigger as the user message.
// companyName is optional and degrades to "this business".
export function buildUnderstandingReviewPrompt({ companyName, transcript } = {}) {
  const name = (companyName && companyName.trim()) ? companyName.trim() : "this business";
  const areaLines = AREAS.map(a => `  - "${a.key}" (${a.label}): ${a.note}`).join("\n");
  const shapeLines = AREAS
    .map(a => `    "${a.key}": { "understanding": "...", "status": "empty|partial|understood", "confidence": 0-100, "openQuestion": "..."|null }`)
    .join(",\n");

  return `You are Compass, reviewing what you have come to understand about ${name} from your conversation with the CEO so far.

Read the conversation transcript below and report your CURRENT UNDERSTANDING of each of these six areas:
${areaLines}

Here "understanding" means Compass's current understanding of that area — what you actually know from the conversation, written in plain, grounded language. It is NOT a generic summary and NOT advice.

RULES:
- Base "confidence" (0-100) honestly on how completely each area was actually covered. Do not inflate.
- An area that was never discussed → status "empty", confidence 0, understanding "" (empty string), openQuestion null.
- An area where the CEO stayed vague even after a follow-up → status "partial", a lower confidence, and a specific "openQuestion" naming exactly what you'd still need to know.
- An area genuinely covered → status "understood", higher confidence, openQuestion null (or a minor one).
- Do not invent facts the CEO did not say. If you don't know, leave it empty or partial.
- "overallSummary" is a 2-3 sentence plain-English summary of what you understand about the business so far.

Return ONLY a single JSON object. No prose, no explanation, no markdown code fences. Exact shape:
{
  "areas": {
${shapeLines}
  },
  "overallSummary": "2-3 sentence plain-English summary of what you understand about the business so far"
}

CONVERSATION TRANSCRIPT:
${transcript || "(no conversation yet)"}`;
}
